//------------------------------>

import React from 'react'
// import AgentPerformance from "./agentPerformance";
// import AgentOfferingTime from "./agentOfferingTime";
import axios from 'axios'
import {
  Card,
  CardContent,
  Typography,
  Paper,
  Chip,
  Tooltip,
  Fade,
  CircularProgress,
  alpha
} from '@mui/material'
import { Alert, Box, IconButton, Snackbar, Stack } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { Grid } from '@mui/material'
import { useState, useEffect } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import {
  Phone,
  PhoneCallback,
  Schedule,
  TrendingUp,
  Analytics,
  CallReceived,
  CallMade,
  AccessTime,
  Restaurant
} from '@mui/icons-material'
import {
  LineChart,
  Line,
  AreaChart,
  Area,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  LabelList,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  Legend
} from 'recharts'
import FilterListIcon from '@mui/icons-material/FilterList'
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import {
  ALL_AGENT_INCOMMING_CALL,
  ALL_AGENT_OUTGOING_CALL,
  ALL_AGENT_CAMPAIGN_DETAILS,
  ALL_AGENT_CAMPAIGN_LEAD_COUNT,
  ALL_AGENT_REGION_LEADS,
  AGENT_REGION_LEADCOUNT,
  REGION_CALLCOUNT,
  GET_DETAILS_BY_MOBILE_NUMBER,
  SHRIMP_LISTING_MASTER
} from '../../constants'
import {
  CALL_STATISTICS,
  OUTGOING_CALL_REPORT,
  PARIVARTAN_CALLING_REPORT
} from '../../constants'

import DateFilterComponent from '../FishFeed/CallingDashboard/DateFilterComponent'

import CallerComponent from '../Dialer/callerComponent'
// import NewLeadFormComponent from "./NewLeadFormComponent";
import dayjs from 'dayjs'
import FilterComponent from './FilterCompoenent'
import IncomingCallDistributionComponent from './IncomingCallDistribution'

// Utility to get date string in YYYY-MM-DD
const getFormattedDate = date => date.toISOString().split('T')[0]

// Enhanced Summary Card with animations and icons
const SummaryCard = ({
  title,
  value,
  subtext,
  icon,
  trend,
  color = 'primary'
}) => {
  const theme = useTheme()

  return (
    <Fade in timeout={800}>
      <Card
        elevation={0}
        sx={{
          borderRadius: 3,
          padding: 2.5,
          background: `linear-gradient(135deg, ${alpha(
            theme.palette[color].main,
            0.1
          )}, ${alpha(theme.palette[color].main, 0.05)})`,
          border: `1px solid ${alpha(theme.palette[color].main, 0.2)}`,
          transition: 'all 0.3s ease',
          height: '100%',
          position: 'relative',
          overflow: 'hidden',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: `0 8px 25px ${alpha(theme.palette[color].main, 0.15)}`
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 3,
            background: `linear-gradient(90deg, ${theme.palette[color].main}, ${theme.palette[color].light})`
          }
        }}
      >
        <Box
          display='flex'
          alignItems='center'
          justifyContent='space-between'
          mb={1}
        >
          <Typography
            variant='subtitle2'
            fontWeight={600}
            color='text.secondary'
          >
            {title}
          </Typography>
          {icon && (
            <Box
              sx={{
                p: 1,
                borderRadius: 2,
                backgroundColor: alpha(theme.palette[color].main, 0.1),
                color: theme.palette[color].main
              }}
            >
              {icon}
            </Box>
          )}
        </Box>

        <Box display='flex' alignItems='baseline' gap={1} mb={1}>
          <Typography variant='h4' color={color} fontWeight='bold'>
            {value}
          </Typography>
          {trend && (
            <Chip
              size='small'
              label={trend}
              color={trend.includes('+') ? 'success' : 'error'}
              variant='outlined'
              sx={{ fontSize: '0.7rem', height: 20 }}
            />
          )}
        </Box>

        {subtext && (
          <Typography variant='caption' color='text.secondary' fontWeight={500}>
            {subtext}
          </Typography>
        )}
      </Card>
    </Fade>
  )
}

// Chart Card wrapper
const ChartCard = ({ title, subtitle, children, action }) => {
  const theme = useTheme()

  return (
    <Fade in timeout={1000}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          background: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(10px)',
          height: '100%'
        }}
      >
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          mb={2}
        >
          <Box>
            <Typography variant='h6' fontWeight='bold' gutterBottom>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant='body2' color='text.secondary'>
                {subtitle}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
        {children}
      </Paper>
    </Fade>
  )
}

const buttonStyle = {
  border: '1px solid #fff',
  borderRadius: '4px',
  margin: '5px',
  width: '40px',
  height: '40px',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#097969',
  color: '#fff',
  transition: 'background-color 0.3s, transform 0.2s',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)'
}

const hoverEffects = (e, isHovering) => {
  e.currentTarget.style.backgroundColor = isHovering ? '#0B9B73' : '#097969'
  e.currentTarget.style.transform = isHovering ? 'scale(1.05)' : 'scale(1)'
}

function IncomingOutgoingCallDashboard () {
  let totalIncoming;
  let totalOutgoing;

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const empDetails = JSON.parse(localStorage.getItem('userData'))
  const location = useLocation()
  const { mobNo, lotNum } = location.state || {} // Destructure the state

  const [tableMobile, setTableMobile] = useState('')
  const [formOpen, setFormOpen] = useState(false)
  const [FormMobileNo, setFormMobileNo] = useState('')
  const [auditMobNum, setAuditMobNum] = useState('')

  const [openSnackbar, setOpenSnackbar] = useState(false)
  const [severity, setSeverity] = useState('')
  const [message, setMessage] = useState('')
  const [dateFilter, setDateFilter] = useState('week')

  const [callID, setCallID] = useState('')
  const [callType, setCallType] = useState('')

  const [missedCallID, setMissdeCalID] = useState('')

  const [statisticsData, setStatisticsData] = useState([])
  const [customStartDate, setCustomStartDate] = useState('')
  const [customEndDate, setCustomEndDate] = useState('')
  const [customApplied, setCustomApplied] = useState(false)

  const [loading, setLoading] = useState(true)

  const getDateRange = filterType => {
    const today = new Date()
    let startDate, endDate

    switch (filterType) {
      case 'today':
        startDate = new Date(today)
        endDate = new Date(today)
        break
      case 'yesterday':
        const yesterday = new Date(today)
        yesterday.setDate(today.getDate() - 1)
        startDate = new Date(yesterday)
        endDate = new Date(yesterday)
        break
      case 'week':
        startDate = new Date(today)
        startDate.setDate(today.getDate() - 6)
        endDate = new Date(today)
        break
      case 'month':
        startDate = new Date(today)
        startDate.setDate(today.getDate() - 29)
        endDate = new Date(today)
        break
      case 'custom':
        startDate = customStartDate
          ? new Date(customStartDate)
          : new Date(today)
        endDate = customEndDate ? new Date(customEndDate) : new Date(today)
        break
      default:
        startDate = new Date(today)
        startDate.setDate(today.getDate() - 6)
        endDate = new Date(today)
    }

    return {
      startDate: getFormattedDate(startDate),
      endDate: getFormattedDate(endDate)
    }
  }

  const agent = JSON.parse(localStorage.getItem('userData'))
  const agentNumber = agent?.EmployeePhone
  //   console.log("agentNumber :::",agentNumber);

  const { startDate, endDate } =
    dateFilter === 'custom' && customApplied
      ? { startDate: customStartDate, endDate: customEndDate }
      : getDateRange(dateFilter)

  const [incoming, setIncoming] = useState(null)
  const [outgoing, setOutgoing] = useState(null)

  const [leadDetailId, setLeadDetailId] = useState('')

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenSnackbar(false)
  }

  // Helper function to get filter display text
  const getFilterDisplayText = () => {
    if (
      dateFilter === 'custom' &&
      customApplied &&
      customStartDate &&
      customEndDate
    ) {
      return `Custom (${customStartDate} to ${customEndDate})`
    }
    switch (dateFilter) {
      case 'today':
        return 'Today'
      case 'yesterday':
        return 'Yesterday'
      case 'week':
        return 'Past 7 Days'
      case 'month':
        return 'Past 30 Days'
      default:
        return 'Past 7 Days'
    }
  }

  const today = dayjs().startOf('day')
  const [filters, setFilters] = useState({
    startDate: today.subtract(6, 'day').format('YYYY-MM-DD'),
    endDate: today.format('YYYY-MM-DD'),
    agentName: ''
  })

  const [callData, setCallData] = useState([])
  const [metricData, setMetricData] = useState([])
  const [filterShow, setFilterShow] = useState(false)
  const [trendData, setTrendData] = useState([])

  const [isLoading, setIsLoading] = useState(true)

  // useEffect(() => {
  //   const checkApiData = async () => {
  //     try {
  //       console.log("check api data ------>>>>>>");
  //       const res = await axios.get(
  //         `${ALL_AGENT_INCOMMING_CALL}?startDate=${startDate}&endDate=${endDate}&agentNumber=${agentNumber}`
  //       );
  //       console.log("Incoming API response:", res.data);
  //     } catch (err) {
  //       console.error("API error:", err);
  //     }
  //   };

  //   checkApiData();
  // }, []);
  // // }, [startDate, endDate, agentNumber]);

  const [agentRegion, setAgentRegion] = useState([])
  const [regioncallCount, setRegioncallCount] = useState([])
  const [campaignLeadCount, setCampaignLeadCount] = useState([])
  const [agentRegionleads, setAgentRegionleads] = useState([])

  useEffect(() => {
    if (dateFilter === 'custom' && !customApplied) return
    const fetchData = async () => {
      try {
        setLoading(true)
        const [incomingRes, outgoingRes, agentRegionCount, regionCallCount,campaignAgentCount ,agentRegionLeads] =
          await Promise.all([
            axios.get(
              `${ALL_AGENT_INCOMMING_CALL}?startDate=${startDate}&endDate=${endDate}`
            ),
            axios.get(
              `${ALL_AGENT_OUTGOING_CALL}?startDate=${startDate}&endDate=${endDate}`
            ),
            axios.get(
              `${AGENT_REGION_LEADCOUNT}?startDate=${startDate}&endDate=${endDate}`
            ),
            axios.get(
              `${REGION_CALLCOUNT}?startDate=${startDate}&endDate=${endDate}`
            ),
            axios.get(`${ALL_AGENT_CAMPAIGN_LEAD_COUNT}?startDate=${startDate}&endDate=${endDate}`),
            axios.get(`${ALL_AGENT_REGION_LEADS}?startDate=${startDate}&endDate=${endDate}`)

          ])

        //   axios.get(
        //     `${GET_DETAILS_BY_MOBILE_NUMBER}?startDate=${startDate}&endDate=${endDate}`
        //   ),

        setIncoming(incomingRes.data)
        setOutgoing(outgoingRes.data)
        setAgentRegion(agentRegionCount.data.data)
        setRegioncallCount(regionCallCount.data.data)
        setCampaignLeadCount(campaignAgentCount.data.data)
        setAgentRegionleads(agentRegionLeads.data.data)

        // for week days --->

        const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        // const totalIncoming = incomingRes.data?.summary?.totalCalls ?? 0
        // const totalOutgoing = outgoingRes.data?.summary?.totalCalls ?? 0
        const generatedTrendData = days.map(day => ({
          day,
          incoming: Math.round(totalIncoming / 7),
          outgoing: Math.round(totalOutgoing / 7)
        }))
        setTrendData(generatedTrendData)
      } catch (error) {
        console.error(error)
        setMessage('Error loading dashboard data')
        setSeverity('error')
        setOpenSnackbar(true)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [dateFilter, startDate, endDate, customApplied])
  
  console.log("incoming--------->",incoming);
  // console.log('AGENT REGION COUNT-----------------> ', agentRegion)
  // console.log('REGION CALL COUNT-----------------> ', regioncallCount)
  // console.log('campaignLeadCount  COUNT-----------------> ', campaignLeadCount)
  // console.log('THISSSSSSSSSSSSSSSSSSSS-----------------> ', agentRegionleads)

  const rechartsData = agentRegion.map(agent => ({
    name: agent.AgentName,
    uv: agent.InboundCount,
    pv: agent.OutboundCount
  }))

  const rechartsData2 = regioncallCount.map(region => ({
    name: region.RegionName,
    incoming: region.InboundCount,
    outgoing: region.OutboundCount
  }))

  const handleFilterChange = newFilter => {
    setDateFilter(newFilter)
    if (newFilter !== 'custom') {
      setCustomApplied(false)
    }
  }

  const data = Array.from({ length: 100 }, (_, i) => ({
    region: `Region ${i + 1}`,
    leads: Math.floor(Math.random() * 491) + 10 // random between 10 and 500
  }))

  const handleCustomDateChange = (type, value) => {
    if (type === 'start') setCustomStartDate(value)
    if (type === 'end') setCustomEndDate(value)
    setCustomApplied(false)
  }

  const handleApplyCustom = (start, end) => {
    setCustomStartDate(start)
    setCustomEndDate(end)
    setCustomApplied(true)
  }

  console.log('CHECK FILTER VALUE:', dateFilter)

  // Prepare chart data
  // const callDistributionData =
  //   incoming && outgoing
  //     ? [
  //         {
  //           name: 'Incoming',
  //           value: incoming?.totalCalls ?? 0,
  //           color: theme.palette.primary.main
  //         },
  //         {
  //           name: 'Outgoing',
  //           // value: outgoing.summary.totalCalls ?? 0,
  //           color: theme.palette.secondary.main
  //         }
  //       ]
  //     : []

  // const connectionRateData =
  //   incoming && outgoing
  //     ? [
  //         {
  //           name: 'Incoming',
  //           connected: incoming?.summary?.connectedCalls?? 0,
  //           missed: incoming?.summary?.missedCalls??0,
  //           // total: incoming?.summary?.totalCalls ?? 0
  //         },
  //         {
  //           name: 'Outgoing',
  //           connected: outgoing?.summary?.connectedCalls ?? 0,
  //           missed: outgoing?.summary?.missedCalls ?? 0,
  //           // total: outgoing?.summary?.totalCalls ?? 0
  //         }
  //       ]
  //     : []

  // Mock trend data (you can replace with actual historical data)
  const trendData1 = [
    { day: 'Mon', incoming: 12, outgoing: 8 },
    { day: 'Tue', incoming: 15, outgoing: 10 },
    { day: 'Wed', incoming: 18, outgoing: 12 },
    { day: 'Thu', incoming: 14, outgoing: 9 },
    { day: 'Fri', incoming: 16, outgoing: 11 },
    { day: 'Sat', incoming: 10, outgoing: 7 },
    { day: 'Sun', incoming: 8, outgoing: 5 }
  ]

  const [isInLoading, setIsInLoading] = useState(true)

  // const fetchIncomingCallStatistics = () => {
  //   const { startDate, endDate } = filters;

  //   const formattedStartDate =
  //     startDate == null || startDate === ""
  //       ? dayjs().subtract(6, "days").format("YYYY-MM-DD")
  //       : dayjs(startDate).format("YYYY-MM-DD");

  //   const formattedEndDate =
  //     endDate == null || endDate === ""
  //       ? dayjs().format("YYYY-MM-DD")
  //       : dayjs(endDate).format("YYYY-MM-DD");

  //   const queryParams = new URLSearchParams();
  //   queryParams.append("startDate", formattedStartDate);
  //   queryParams.append("endDate", formattedEndDate);
  //   queryParams.append("agentName", empDetails.EmployeeName);
  //   setIsInLoading(true);
  //   axios
  //     .get(`${PARIVARTAN_CALLING_REPORT}?${queryParams.toString()}`)
  //     .then((response) => {
  //       const { data } = response.data;
  //       setCallData(data.agents);
  //       setMetricData(data.summary.metrics);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     }).finally(() => {
  //       setIsInLoading(false); // Stop loading after data fetch
  //     });
  // };

  const [connectedCalls, setConnectedCalls] = useState([])
  const [notConnectedCalls, setNotConnectedCalls] = useState([])
  const [totalOutCall, setTotalOutCall] = useState(0)

  const fetchOutgoingCallStatistics = () => {
    const { startDate, endDate } = filters

    const formattedStartDate = dayjs(startDate).format('YYYY-MM-DD')
    const formattedEndDate = dayjs(endDate).format('YYYY-MM-DD')

    const queryParams = new URLSearchParams()
    queryParams.append('startDate', formattedStartDate)
    queryParams.append('endDate', formattedEndDate)
    queryParams.append('aPartyNo', empDetails.EmployeePhone)
    setIsLoading(true)
    axios
      .get(`${OUTGOING_CALL_REPORT}?${queryParams.toString()}`)
      .then(response => {
        // setTotalOutCall(response.data.totalCalls)
        setConnectedCalls(response.data.connected)
        setNotConnectedCalls(response.data.notConnected)
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        setIsLoading(false) // Stop loading after data fetch
      })
  }

  const [filtersLoaded1, setFiltersLoaded1] = useState(false) // Track if filters are loaded

  // all agents apis call---------->
  const [chartData, setChartData] = useState([])
  const [chartData2, setChartData2] = useState([])
  const [chartData3, setChartData3] = useState([])

  const fetchDashboardData = async () => {
    try {
      const [campaigns, campaignLeadCount, regionLeads, agentRegionLeadCount] =
        await Promise.all([
          // axios.get(ALL_AGENT_CAMPAIGN_DETAILS),
          axios.get(ALL_AGENT_CAMPAIGN_LEAD_COUNT),
          axios.get(ALL_AGENT_REGION_LEADS)
          // axios.get(AGENT_REGION_LEADCOUNT),
          // axios.get( `${AGENT_REGION_LEADCOUNT}?startDate=${startDate}&endDate=${endDate}`)
        ])

      console.log('Campaigns:', campaigns.data)
      console.log('Campaign Lead Count:', campaignLeadCount.data)
      console.log('Region Leads:', regionLeads.data)
      // console.log('Agent Region Lead Count:', agentRegionLeadCount)
      return {
        campaigns: campaigns.data,
        campaignLeadCount: campaignLeadCount.data,
        regionLeads: regionLeads.data
        // agentRegionLeadCount: agentRegionLeadCount
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error)
      throw error
    }
  }

  console.log('seeeeeeeeee', chartData3)

  // const formattedData = chartData.map(item => ({
  //   region: item.region_name,
  //   leads: item.leadCount,
  // }));

  // console.log("1111111111111",formattedData);

  useEffect(() => {
    // Load filters from localStorage on page load
    const savedFilters = localStorage.getItem('dashboardfilters')

    if (savedFilters) {
      const loadedFilters = JSON.parse(savedFilters)

      // Check if the filters have changed compared to the initial state
      if (
        loadedFilters.startDate !== filters.startDate ||
        loadedFilters.endDate !== filters.endDate ||
        loadedFilters.agentName !== filters.agentName
      ) {
        setFilters(loadedFilters) // Only set the new filters if they are different
      }
    }

    // Set filtersLoaded to true after initial load to prevent premature API call
    setFiltersLoaded1(true)
  }, []) // This runs only once on initial load

  // useEffect(() => {
  //   // Only fetch the data if filters are loaded and filters state has changed
  //   if (
  //     filtersLoaded1 &&
  //     JSON.stringify(filters) !==
  //       JSON.stringify({
  //         startDate: dayjs().subtract(6, "days").toDate(),
  //         endDate: dayjs().toDate(),
  //         agentName: "",
  //       })
  //   ) {
  //     fetchIncomingCallStatistics(); // Fetch data if filters have changed
  //     // fetchOutgoingCallStatistics();
  //   }
  // }, [filters, filtersLoaded1]); // Re-fetch when filters change

  // dummy data

  // const incomingVal = {
  //   summary: {
  //     // totalCalls: 20,
  //     connectedCalls: 14,
  //     missedCalls: 6,
  //     totalDuration: '00:42:30' // Format: HH:MM:SS
  //   }
  // }

  // const outgoingVal = {
  //   summary: {
  //     // totalCalls: 25,
  //     connectedCalls: 18,
  //     missedCalls: 7, // "Not Connected"
  //     totalDuration: '01:05:45' // Format: HH:MM:SS
  //   }
  // }

  const callDistributionDataVal = [
    { name: 'Incoming', value: 40, color: '#1976d2' }, // primary
    { name: 'Outgoing', value: 60, color: '#9c27b0' } // secondary
  ]

  const connectionRateDataVal = [
    { name: 'Agent A', connected: 20, missed: 5 },
    { name: 'Agent B', connected: 15, missed: 8 },
    { name: 'Agent C', connected: 25, missed: 4 },
    { name: 'Agent D', connected: 18, missed: 6 },
    { name: 'Agent E', connected: 10, missed: 10 }
  ]

  const trendDataVal = [
    { day: 'Mon', incoming: 12, outgoing: 8 },
    { day: 'Tue', incoming: 9, outgoing: 11 },
    { day: 'Wed', incoming: 15, outgoing: 10 },
    { day: 'Thu', incoming: 8, outgoing: 14 },
    { day: 'Fri', incoming: 10, outgoing: 13 },
    { day: 'Sat', incoming: 6, outgoing: 9 },
    { day: 'Sun', incoming: 4, outgoing: 5 }
  ]

  console.log('outgoing:::', outgoing)

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{
          minHeight: '100vh', // Make the container take full viewport height
          flexWrap: 'wrap'
        }}
        justifyContent='center' // Center horizontally
        alignItems='center' // Center vertically
      >
        {/* Conditional Content Based on formOpen */}
        {formOpen ? (
          <>
            {/* Existing Data Section */}
            <Grid
              item
              xs={12}
              sm={5}
              md={6}
              style={{
                flexGrow: 1 // Make this take up remaining space
              }}
            >
              {/* <ExistingTimelineComponent
                FormMobileNo={FormMobileNo}
                leadDetailId={leadDetailId}
                
              /> */}
            </Grid>

            {/* Audit Form Section */}
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              style={{
                flex: '1 1 350px', // Ensure AuditFormComponent has a minimum width
                minWidth: '300px' // Minimum width for responsiveness
              }}
            >
              {/* <NewLeadFormComponent
                setFormOpen={setFormOpen}
                FormMobileNo={FormMobileNo}
                setOpenSnackbar={setOpenSnackbar}
                setSeverity={setSeverity}
                setMessage={setMessage}
                mobNo={mobNo}
                setLeadDetailId={setLeadDetailId}
                
              /> */}
            </Grid>
          </>
        ) : (
          <>
            {/* Filter and Performance Section */}

            <Grid
              item
              xs={12}
              marginLeft={5}
              marginRight={3}
              style={{
                flex: '1 1 350px', // Ensure AuditFormComponent has a minimum width
                minWidth: '300px' // Minimum width for responsiveness
              }}
            >
              {/* Header Section */}
              <Box sx={{ mb: 4 }}>
                <Box display='flex' alignItems='center' gap={2} mb={1}>
                  {/* <Restaurant color="primary" sx={{ fontSize: 32 }} /> */}
                  <Typography variant='h4' fontWeight='bold' color='primary'>
                    All Agent Calls.
                  </Typography>
                </Box>
                <Box display='flex' alignItems='center' gap={1} mb={3}>
                  <Schedule fontSize='small' color='action' />
                  <Typography variant='body1' color='text.secondary'>
                    Analytics for {getFilterDisplayText()}:{' '}
                    <strong>{startDate}</strong> to <strong>{endDate}</strong>
                  </Typography>
                </Box>

                {/* DATE FILTER COMPONENT */}
                <DateFilterComponent
                  selectedFilter={dateFilter}
                  onFilterChange={handleFilterChange}
                  customStartDate={customStartDate}
                  customEndDate={customEndDate}
                  onCustomDateChange={handleCustomDateChange}
                  onApplyCustom={handleApplyCustom}
                />
              </Box>

              {/* Key Metrics Cards - Incoming */}
              <Grid container spacing={3} mb={4}>
                {incoming && (
                  <>
                    <Grid item xs={12} sm={6} md={3}>
                      <SummaryCard
                        title='Incoming Calls'
                        value={incoming?.totalCalls || 0}
                        icon={<CallReceived />}
                        color='primary'
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SummaryCard
                        title='Connected (In)'
                        value={incoming?.connectedCalls || 0}
                        icon={<Phone />}
                        color='success'
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SummaryCard
                        title='Missed (In)'
                        value={incoming?.missedCalls || 0}
                        icon={<PhoneCallback />}
                        color='warning'
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SummaryCard
                        title='Duration (In)'
                        value={incoming?.totalDuration || "0:00:00"}
                        icon={<AccessTime />}
                        color='info'
                      />
                    </Grid>
                  </>
                )}
              </Grid>

              {/* Key Metrics Cards - Outgoing */}
              {/* <Grid container spacing={3} mb={4}>
                {outgoingVal && (
                  <>
                    <Grid item xs={12} sm={6} md={3}>
                      <SummaryCard
                        title='Outgoing Calls'
                        // value={outgoing?.summary?.totalCalls ?? 0}
                        icon={<CallMade />}
                        color='secondary'
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SummaryCard
                        title='Connected (Out)'
                        value={outgoing?.summary?.connectedCalls ?? 0}
                        icon={<Phone />}
                        color='success'
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SummaryCard
                        title='Not Connected'
                        value={outgoing?.summary?.missedCalls ?? 0}
                        icon={<PhoneCallback />}
                        color='warning'
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SummaryCard
                        title='Duration (Out)'
                        value={outgoing?.summary?.totalDuration ?? 0}
                        icon={<AccessTime />}
                        color='info'
                      />
                    </Grid>
                  </>
                )}
              </Grid> */}

              {/* Charts Section */}
              <Grid container spacing={3} mb={4}>
                {/* Call Distribution Pie Chart */}
                {/* <Grid item xs={12} md={4}>
                  <ChartCard
                    title='Call Distribution'
                    subtitle='Incoming vs Outgoing calls'
                    action={
                      <Tooltip title='View analytics'>
                        <IconButton>
                          <Analytics />
                        </IconButton>
                      </Tooltip>
                    }
                  >
                    <ResponsiveContainer width='100%' height={250}>
                      <PieChart>
                        <Pie
                          data={callDistributionData}
                          cx='50%'
                          cy='50%'
                          outerRadius={80}
                          dataKey='value'
                          label={({ name, percent }) =>
                            `${name} ${(percent * 100).toFixed(0)}%`
                          }
                        >
                          {callDistributionData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}
                        </Pie>
                        <RechartsTooltip />
                        <Legend />
                      </PieChart>
                    </ResponsiveContainer>
                  </ChartCard>
                </Grid> */}

                {/* Connection Rate Bar Chart */}
                <Grid item xs={12} md={8}>
                  {/* <ChartCard
                    title='Connection Analysis'
                    subtitle='Connected vs Missed calls'
                    action={
                      <Tooltip title='View trends'>
                        <IconButton>
                          <TrendingUp />
                        </IconButton>
                      </Tooltip>
                    }
                  >
                    <ResponsiveContainer width='100%' height={250}>
                      <BarChart data={connectionRateData}>
                        <CartesianGrid
                          strokeDasharray='3 3'
                          stroke={alpha(theme.palette.divider, 0.3)}
                        />
                        <XAxis dataKey='name' />
                        <YAxis />
                        <RechartsTooltip />
                        <Legend />
                        <Bar
                          dataKey='connected'
                          stackId='a'
                          fill={theme.palette.success.main}
                          name='Connected'
                        />
                        <Bar
                          dataKey='missed'
                          stackId='a'
                          fill={theme.palette.warning.main}
                          name='Missed'
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </ChartCard> */}
                  <Box sx={{ width: '100%' }} className='border rounded-xl'>
                    <Box display='flex' alignItems='center' gap={2} mb={1}>
                      <Typography
                        variant='h6'
                        fontWeight='bold'
                        // color='primary'
                        className='pb-10 pl-8 pt-10'
                      >
                        Incoming Outgoing Call Count
                      </Typography>
                    </Box>

                    <Box sx={{ width: '100%', minWidth: 500, height: 400 }}>
                      <ResponsiveContainer width='100%' height='100%'>
                        {Array.isArray(rechartsData) &&
                        rechartsData.length > 0 ? (
                          <BarChart
                            data={rechartsData}
                            margin={{
                              top: 20,
                              right: 30,
                              left: 20,
                              bottom: 80
                            }}
                            barCategoryGap={32}
                            barGap={6}
                          >
                            <XAxis
                              dataKey='name'
                              angle={-45}
                              textAnchor='end'
                              interval={0}
                              height={80}
                            />
                            <YAxis />
                            <RechartsTooltip
                              formatter={(value, name) => {
                                const labels = {
                                  uv: 'Inbound',
                                  pv: 'Outbound'
                                }
                                return [`${value} calls`, labels[name] || name]
                              }}
                            />
                            <Legend
                              wrapperStyle={{
                                paddingTop: 40,
                                textAlign: 'center'
                              }}
                            />
                            <Bar
                              dataKey='uv'
                              fill='#82ca9d'
                              name='Inbound'
                              barSize={28}
                            >
                              <LabelList dataKey='uv' position='top' />
                            </Bar>
                            <Bar
                              dataKey='pv'
                              fill='#A0D8EF'
                              name='Outbound'
                              barSize={28}
                            >
                              <LabelList dataKey='pv' position='top' />
                            </Bar>
                          </BarChart>
                        ) : (
                          <Box
                            display='flex'
                            justifyContent='center'
                            alignItems='center'
                            height='100%'
                            width='100%'
                            borderRadius='16px'
                            sx={{ backgroundColor: '#f9f9f9' }}
                          >
                            <Typography variant='h6' color='textSecondary'>
                              No call data available for the selected range.
                            </Typography>
                          </Box>
                        )}
                      </ResponsiveContainer>
                    </Box>
                  </Box>
                </Grid>

                {/* Weekly Trend Line Chart */}
                {/* <Grid item xs={12}>
                    <ChartCard
                      title="Call Trends"
                      subtitle={`Daily call patterns for ${getFilterDisplayText().toLowerCase()}`}
                    >
                      <ResponsiveContainer width="100%" height={300}>
                        <AreaChart data={trendData}>
                          <defs>
                            <linearGradient id="colorIncoming" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor={theme.palette.primary.main} stopOpacity={0.3} />
                              <stop offset="95%" stopColor={theme.palette.primary.main} stopOpacity={0} />
                            </linearGradient>
                            <linearGradient id="colorOutgoing" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor={theme.palette.secondary.main} stopOpacity={0.3} />
                              <stop offset="95%" stopColor={theme.palette.secondary.main} stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" stroke={alpha(theme.palette.divider, 0.2)} />
                          <XAxis dataKey="day" />
                          <YAxis />
                          <RechartsTooltip />
                          <Legend />
                          <Area
                            type="monotone"
                            dataKey="incoming"
                            stroke={theme.palette.primary.main}
                            fillOpacity={1}
                            fill="url(#colorIncoming)"
                            name="Incoming Calls"
                          />
                          <Area
                            type="monotone"
                            dataKey="outgoing"
                            stroke={theme.palette.secondary.main}
                            fillOpacity={1}
                            fill="url(#colorOutgoing)"
                            name="Outgoing Calls"
                          />
                        </AreaChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid> */}
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
       <Grid
        container
        spacing={2}
        style={{
          minHeight: '100vh', // Make the container take full viewport height
          flexWrap: 'wrap'
        }}
        justifyContent='center' // Center horizontally
        alignItems='center' // Center vertically
      >
       <Box display='flex' alignItems='center' gap={2} mb={1}>
          <Typography
            variant='h4'
            fontWeight='bold'
            color='primary'
            className='pl-8'
          >
            Region-wise Lead Count
          </Typography>
        </Box> 
<div style={{ width: '100%', overflowX: 'auto', marginRight: '24px' }}>
  {agentRegionleads.length === 0 ? (
    <div style={{ textAlign: 'center', padding: '50px', fontSize: '18px', color: '#6b7280' }}>
      No data available
    </div>
  ) : (
    <div
      style={{ width: Math.max(agentRegionleads.length * 40, 800), height: 400 }}
    >
      <ResponsiveContainer width='100%' height='100%'>
        <BarChart
          data={agentRegionleads.map(item => ({
            region: item.region_name,
            leads: item.leadCount
          }))}
          margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
          barCategoryGap='5%'
        >
          <XAxis
            dataKey='region'
            angle={-45}
            textAnchor='end'
            interval={0}
            fontSize={13}
          />
          <YAxis />
          <RechartsTooltip />
          <Bar
            dataKey='leads'
            fill='#3b82f6' // Tailwind blue-500
            barSize={20}
            label={{
              position: 'top',
              fill: '#111827',
              fontSize: 14
            }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )}
</div>

      </Grid>

       <Box display='flex' alignItems='center' gap={2} mb={1}>
        <Typography
          variant='h4'
          fontWeight='bold'
          color='primary'
          className='pb-10 pl-8 pt-10'
        >
          Campaign-wise Lead Count
        </Typography>
      </Box> 

       <div style={{ width: '100%', overflowX: 'auto', marginRight: '24px' }}>
        <div
          style={{ width: Math.max(campaignLeadCount.length * 49, 800), height: 400 }}
        >
          <ResponsiveContainer width='100%' height='100%'>
            <BarChart
              data={campaignLeadCount.map(item => ({
                campaignName: item.campaignName,
                leads: item.leadCount
              }))}
              margin={{ top: 20, right: 30, left: 20, bottom: 150 }}
              barCategoryGap='5%' // reduce the space between categories
            >
              <XAxis
                dataKey='campaignName'
                angle={-45}
                textAnchor='end'
                interval={0}
                style={{ fontSize: 12 }} // 👈 change this value as needed
              />
              <YAxis />
              <RechartsTooltip />
              <Bar
                dataKey='leads'
                fill='#facc15'
                barSize={20}
                // this label is for leads text above bars----->
                label={{
                  position: 'top',
                  fill: '#111827',
                  fontSize: 13
                }}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div> 

      {/* // yaha  */}

      {/* <Box display='flex' alignItems='center' gap={2} mb={1}>
        <Typography
          variant='h4'
          fontWeight='bold'
          color='primary'
          className='pb-10 pl-8 pt-10'
        >
          Incoming Outgoing Call Count
        </Typography>
      </Box> */}

   <Box sx={{ width: '100%' }} className='border rounded-xl'>
  <Box display='flex' alignItems='center' gap={2} mb={1}>
    <Typography
      variant='h6'
      fontWeight='bold'
      color='primary'
      className='pb-10 pl-8 pt-10'
    >
      Regional Incoming & Outgoing Calls
    </Typography>
  </Box>

  <Box sx={{ width: '100%', minWidth: 500, height: 500 }}>
    {Array.isArray(rechartsData2) && rechartsData2.length > 0 ? (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={rechartsData2}
          margin={{ top: 20, right: 30, left: 20, bottom: 100 }}
          barCategoryGap={32}
          barGap={8}
        >
          <XAxis
            dataKey="name"
            angle={-45}
            textAnchor="end"
            interval={0}
            height={100}
            tick={{ fontSize: 12 }}
          />
          <YAxis tick={{ fontSize: 14 }} domain={[0, 'dataMax']} />
          <RechartsTooltip formatter={(value, name) => {
            const labels = {
              incoming: 'Inbound',
              outgoing: 'Outbound'
            };
            return [`${value} calls`, labels[name] || name];
          }} />
          <Legend
            wrapperStyle={{
              paddingTop: 30,
              textAlign: 'center'
            }}
          />
          <Bar dataKey="incoming" fill="#82ca9d" name="Inbound" barSize={32} />
          <Bar dataKey="outgoing" fill="#A0D8EF" name="Outbound" barSize={32} />
        </BarChart>
      </ResponsiveContainer>
    ) : (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
        minHeight={400}
      >
        <Typography variant="h6" color="textSecondary">
          No call data available for the selected range.
        </Typography>
      </Box>
    )}
  </Box>
</Box>

      {/* // HORIZONTAL BAR (just in case)     */}
      {/* <div className="w-full flex justify-center">
  <div style={{ width: '80%' }}>
    <div
      style={{
        height: chartData.length * 30,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout="vertical"
          data={chartData.map(item => ({
            region: item.region_name,
            leads: item.leadCount,
          }))}
          margin={{ top: 20, right: 30, left: 120, bottom: 20 }}
        >
          <XAxis type="number" hide />
          <YAxis
            type="category"
            dataKey="region"
            width={150}
            tick={{ fontSize: 12 }}
          />
          <RechartsTooltip />
          <Bar
            dataKey="leads"
            fill="#2563eb"
            label={{
              position: 'insideRight',
              fill: '#ffffff',
              fontSize: 12,
            }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
</div> */}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  )
}

export default IncomingOutgoingCallDashboard
